export default __webpack_public_path__ + "static/media/five.b890a7ac.jpeg";